import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { TypedDispatch } from 'shared/model/types';

import {emailConfirmationRequest} from './thunks/emailConfirmationRequest';

const useEmailConfirmation = () => {
    const dispatch = useDispatch<TypedDispatch>();

    return async() => {
        try {
            const resultAction = await dispatch(emailConfirmationRequest());
            const response = unwrapResult(resultAction);
            toast.info(response.message);
            return true;
        } catch (error: any) {
            return false;
        }
    };
};

export default useEmailConfirmation;